import { render, staticRenderFns } from "./growth_rules.vue?vue&type=template&id=0b49a394&scoped=true"
import script from "./growth_rules.vue?vue&type=script&lang=js"
export * from "./growth_rules.vue?vue&type=script&lang=js"
import style0 from "./growth_rules.vue?vue&type=style&index=0&id=0b49a394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49a394",
  null
  
)

export default component.exports